import React, { Component, useEffect } from 'react';
import '../styles/App.css';
import "aos/dist/aos.css";
import Aos from 'aos';
import Carousel2 from '../components/carousel2';

const Stry = () => {
    useEffect(() => {
        Aos.init({ duration: 4000 });
    }, [])
}

class Mint extends Component {

    render() {
        return (

            <div>
                <div class="iframe">
                    <div class="conT" data-aos="zoom-in" data-aos-duration="700">MINT</div>
                    <p></p>
                    <div class="conT2" data-aos="zoom-in" data-aos-duration="700">Mint your NFT Bunda Angels</div>
                    <div className="w-full h-screen">

                        <iframe
                            src="https://www.crossmint.com/collections/bunda-angels/drop"
                            className="w-full h-full border-none"                          
                            title="Crossmint Drop"
                            allow="clipboard-write"
                        ></iframe>
                    </div>

                    <Carousel2 />

                </div>

                
            </div>
        )
    }
}

export default Mint;

